import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import b03 from "../../../../assets/notarymeet/b03.png"
import b033 from "../../../../assets/notarymeet/b033.png"

import '../notarymeet.css'


function B03() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor: isSmallScreen ? "#343434" : "#EEEDEB",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
        {isSmallScreen ? (
          <Image src={b033} alt='b033' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        ) : (
          <Image src={b03} alt='b03' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        )}
       
    </Container>
    
     
    
  )
}

export default B03
